import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

export type FormFieldError = {
  /** Chemin du champ, ex. `informationBlock.title` */
  field: string;
  /** Clé du validateur en échec, ex. `required`, `minlength` */
  error: string;
};

/** Liste récursivement les erreurs de validation d'un formulaire (groupes compris). */
export function collectFormErrors(control: AbstractControl, path: string = ''): FormFieldError[] {
  const own: FormFieldError[] = Object.keys(control.errors ?? {}).map((error: string) => ({
    field: path || 'form',
    error,
  }));

  if (!(control instanceof FormGroup || control instanceof FormArray)) return own;

  const children: FormFieldError[] = Object.entries(control.controls).flatMap(
    ([key, child]: [string, AbstractControl]) =>
      collectFormErrors(child, path ? `${path}.${key}` : key),
  );
  return [...own, ...children];
}
